<div class="name-field">
  <div class="avatar">
    <app-avatar
      [name]="firstName + ' ' + lastName"
      [userId]="userId"
      [width]="40"
      [height]="40"
      [hasImage]="
        userAccount.userId === userId ? !!userAccount.picture : !!profilePic
      "
      [picUrl]="
        userAccount.userId === userId ? userAccount.picture : profilePic
      "
      [showBadge]="showBadge"
      [badgeSize]="18"
      [workspaces]="workspaces"
      [identityVerificationStatus]="identityVerificationStatus"
      [showTooltip]="false"
      [user]="user"
      [isExternal]="user?.isExternal ?? false"
    >
    </app-avatar>
  </div>
  <div class="name ml-2 font-14">
    @if (userAccount.userId === userId) {
      <div>
        {{
          mustShowName
            ? firstName + " " + lastName
            : firstName + " " + lastName + " (You)"
        }}
      </div>
    }
    @if (userAccount.userId !== userId) {
      <div>{{ firstName }} {{ lastName }}</div>
    }
    @if (description) {
      <div class="font-12 font-grey">
        {{ description }}
      </div>
    }
  </div>
</div>
